"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@workos-inc/authkit-nextjs/components";
import posthog from "posthog-js";
import { useEffect } from "react";
import { syncPostHogIdentity, toPostHogIdentityUser, type PostHogIdentityUser } from "@/lib/sync-posthog-identity";
export function PostHogIdentifySync(t0) {
  const $ = _c(10);
  const {
    loading,
    user
  } = t0;
  let t1;
  if ($[0] !== loading || $[1] !== user) {
    t1 = () => {
      syncPostHogIdentity(posthog, {
        loading,
        user
      });
    };
    $[0] = loading;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = user?.id;
  const t3 = user?.email;
  const t4 = user?.firstName;
  const t5 = user?.lastName;
  let t6;
  if ($[3] !== loading || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== user) {
    t6 = [loading, user, t2, t3, t4, t5];
    $[3] = loading;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = user;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t1, t6);
  return null;
}
export function PostHogIdentify() {
  const $ = _c(5);
  const {
    loading,
    user
  } = useAuth();
  let t0;
  if ($[0] !== user) {
    t0 = user ? toPostHogIdentityUser(user) : null;
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== loading || $[3] !== t0) {
    t1 = <PostHogIdentifySync loading={loading} user={t0} />;
    $[2] = loading;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}